(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("PlatformComponents", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["PlatformComponents"] = factory(require("React"), require("ReactDOM"));
	else
		root["PlatformComponents"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__7__) {
return 